import { createContext, useContext, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  connectSocket,
  disconnectSocket,
  getSocket,
  attachRecoveryListeners,
} from "../services/socket";
import api from "../services/api";
import { toast } from "react-toastify";
import { notifyMe } from "../services/helper";

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const token = api.getToken();
    if (!token) return;

    const socket = connectSocket(token);
    const detachRecovery = attachRecoveryListeners();


    const notificationHandlers = {
      "notify_user": (data) => {
        notifyMe(data);

        queryClient.invalidateQueries({ queryKey: ["user-notifications"] });

        // Optional: Handle specific notification types
        // if (data?.type === "new_message") {
        //   queryClient.invalidateQueries({ queryKey: ["all_chats"] });
        // }
      },

      "new_follow_request": (data) => {
        notifyMe(data);

        queryClient.invalidateQueries({ queryKey: ["pending-requests"] });
      },

      "notification_admin": (data) => {
        notifyMe(data);

        queryClient.invalidateQueries({ queryKey: ["admin-notifications"] });
      },
      "challenge_update": (data) => {
        // notifyMe(data);
        queryClient.invalidateQueries({ queryKey: ["current-challenge"] });
      },
      "live_room_changes": (data) => {
        // notifyMe(data);
        queryClient.invalidateQueries({ queryKey: ["all_chats"] });
      },


      // Add more event handlers here as needed
      // "new_like": () => queryClient.invalidateQueries({ queryKey: ["my-posts"] }),
    };

    // Attach listeners
    Object.entries(notificationHandlers).forEach(([event, handler]) => {
      socket.on(event, handler);
    });

    return () => {
      // Cleanup listeners
      Object.keys(notificationHandlers).forEach((event) => {
        socket.off(event);
      });

      detachRecovery();
      disconnectSocket();
    };
  }, [queryClient]); // queryClient is stable, so it's safe

  return (
    <SocketContext.Provider value={getSocket()}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);